import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Examine from "../../Assets/Projects/Examine.png";
import filmpire from "../../Assets/Projects/filmpire.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import MovieDB from "../../Assets/Projects/MovieDB.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import AmongUs from '../../Assets/Projects/AmongUs.png'
import lbhmarket from '../../Assets/Projects/lbhmarket.png'

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lbhmarket}
              isBlog={false}
              title="LBH Market"
              description="An online ecommerce retail store buit using NextJs, TailwindCss and AdonisJs"
              ghLink=""
              demoLink="https://lbhmarket.com/"
            />
          </Col> 

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col> */}

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AmongUs}
              isBlog={false}
              title="Among Us"
              description="Recreation of the popular AmongUs game"
              ghLink="https://github.com/Benedict-Kpaduwa/Among-Us"
              demoLink=""              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Examine}
              isBlog={false}
              title="Examine"
              description="Login and Signup Page for Examine"
              ghLink="https://github.com/Benedict-Kpaduwa/Examine"
              demoLink="https://examine-nine.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={MovieDB}
              isBlog={false}
              title="Movie DataBase"
              description="An online movie database that allows users to view list of available movies to watch from, review them and rate it"
              ghLink="https://github.com/Benedict-Kpaduwa/React-Movie-Database"
              demoLink="https://benedictkrmdb.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={filmpire}
              isBlog={false}
              title="Filmpire"
              description="An movie website for checking out movies, viewing trailers, adding to watchlist. It also has an AI powered voice control"
              //ghLink=""
              demoLink="https://filmpirex.netlify.app/" 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
